module.exports = __webpack_public_path__ + "static/trevor-noah-ad75b34018d544210ca2ea805835539c.jpg";